import styled from 'styled-components';

import ResetBg from '@src/theme/assets/backgrounds/abstract-white-bg.webp';

export const StyledResetPasswordPage = styled.div`
  width: 100%;

  .reset-password-page {
    width: 100%;
    min-height: calc(100vh - 180px);
    display: flex;
    flex-direction: column;
    padding: 60px 24px 80px;
    justify-content: center;
    align-items: center;
    background-image: url(${ResetBg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &__container {
      width: 100%;
      max-width: 460px;
      background-color: ${({ theme }) => theme.colors.white};
      border-radius: 16px;
      padding: 48px 40px;
      box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1);
    }
  }

  @media (max-width: 600px) {
    .reset-password-page {
      padding: 40px 16px 60px;

      &__container {
        padding: 36px 24px;
      }
    }
  }
`;
